import { render } from "./GraphicDesignRequest.vue?vue&type=template&id=705b9c0e"
import script from "./GraphicDesignRequest.vue?vue&type=script&lang=js"
export * from "./GraphicDesignRequest.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__